import { createUnknownErrorResult } from '@/entities/FetchResult'
import { FetchCollectionResult, FetchResultType } from '@/entities/FetchResult'
import { authorizedFetch } from '@/helpers/authorizedFetch'
import { reportError, reportMessage } from '@/helpers/errorReporting'
import { generateApiUrl } from '@/helpers/url'
import { isResourceCollectionDocument } from '@/japi/guards/isResourceCollectionDocument'
import { JapiDocument } from '@/japi/types/Document'

import { TimerUser, UserResource } from './User'
import { transformToTimerUser } from './UserTransformers'

export const getTimerUsersApiCall = async (): Promise<FetchCollectionResult<TimerUser[], string>> => {
    try {
        const url = generateApiUrl({ endpoint: '/api/v2/users' })

        const response = await authorizedFetch(url)

        const doc: JapiDocument = await response.json()

        if (! isResourceCollectionDocument<UserResource>(doc) || ! doc.data) {
            reportMessage('getTimerUsersApiCall', `getTimerUsersApiCall failed with status code ${response.status}`)

            return createUnknownErrorResult(response.status)
        }

        const users = doc.data.map(transformToTimerUser)

        return {
            amountOfPages: 1,
            status: response.status,
            type: FetchResultType.Success,
            data: users,
        }
    } catch (error) {
        reportError('getTimerUsersApiCall', error)

        return createUnknownErrorResult(500)
    }
}
